var _path, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHandLuggageIcon = function SvgHandLuggageIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_1047",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 1047",
    width: 8.261,
    height: 9.586,
    viewBox: "0 0 8.261 9.586",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_8336",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 8336",
    d: "M1.18,0h5.9a1.192,1.192,0,0,1,1.18,1.2V6.321a1.192,1.192,0,0,1-1.18,1.2H1.18A1.192,1.192,0,0,1,0,6.321V1.2A1.192,1.192,0,0,1,1.18,0Z",
    transform: "translate(0 2.061)",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_106",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 106",
    transform: "translate(1.515)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.588,
    cy: 2.588,
    rx: 2.588,
    ry: 2.588,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.588,
    cy: 2.588,
    rx: 2.088,
    ry: 2.088,
    fill: "none"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHandLuggageIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/handLuggageIcon.222a7c0f.svg";
export { ForwardRef as ReactComponent };